





















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class BaseSwitch extends Vue {
  @Prop({ type: Boolean, required: true })
  readonly value!: boolean;

  // The Buefy type for the switch color (e.g., 'is-success', 'is-info').
  @Prop({ type: String, default: 'is-success' })
  readonly type!: string;

  // Prop to disable the switch.
  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;


  @Emit('input')
  emitInput(newValue: boolean) {
    return newValue;
  }
}
